function Dipespliderazgogestionequipos() {
    return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Habilidades Blandas fortalece las capacidades 
                    interpersonales y de gestión personal de los participantes, promoviendo un 
                    desarrollo integral que complemente los conocimientos técnicos y estratégicos.
               </p>
               <p>
                    El programa aborda contenidos vinculados a comunicación efectiva, liderazgo 
                    y motivación, trabajo en equipo, inteligencia emocional, resolución de conflictos, 
                    negociación y gestión del tiempo.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar competencias interpersonales que potencien la comunicación, 
                            liderazgo, trabajo en equipo y resolución de conflictos, mejorando 
                            el desempeño profesional y la armonía organizacional.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img 
                    src='/uploads/curs_trabajo_social.jpg' 
                    alt='logo-de-metodologia' 
                    className='logo-metodologia'
                />
                
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 Teléfonos y WhatsApp: 913376365 / 948251685</p>
                        <p>📧 Correos: esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Comunicación Efectiva </li>
                    <li> 2. Liderazgo y Motivación </li>
                    <li> 3. Trabajo en Equipo </li>
                    <li> 4. Inteligencia Emocional </li>
                    <li> 5. Resolución de Conflictos </li>
                    <li> 6. Negociación </li>
                    <li> 7. Gestión del Tiempo </li>
                </ul>
            </div>
        </div>
    );
}

export default Dipespliderazgogestionequipos
